/** 検索タイプの定数 */
export const SEARCH_TYPES = {
  /** 現在の場所で検索する */
  CURRENT_PLACE: 'currentPlace',
  /** 住所のキーワードで検索する */
  ADDRESS: 'address',
  /** 駐車場名のキーワードで検索する */
  PARKING_NAME: 'parkingName',
  /** エリア検索から選択した市区町村で検索する */
  SELECTED_ADDRESS: 'selectedAddress',
} as const;

/** ボトムシート表示切り替え定数 */
export const SELECTOR_MODE = {
  NONE: 'none',
  PARKING: 'parking',
  PREFECTURE: 'prefecture',
  CITY: 'city',
  AREA_PARKING: 'areaParking',
} as const;

export const searchTypeOptions = [
  { id: 'address', value: 'address', label: '住所から検索' },
  { id: 'parkingName', value: 'parkingName', label: '駐車場名から検索' },
];

// 支払いのステップ
export const PAYMENT_STEPS = {
  SELECT: 1,
  CONFIRM: 2,
  COMPLETE: 3,
  OUTDATE: 4,
  OVER_LIMIT: 5,
} as const;
export type PaymentStep = (typeof PAYMENT_STEPS)[keyof typeof PAYMENT_STEPS];

// 対象の駐車場で決済可能な最大範囲（半径[m]）
export const VALID_DISTANCE = 100;

// 出庫方法
export const PAYMENT_FLOWS = {
  CASH: 'cash',
  PASS: 'pass',
  FREE: 'free', // 0円決済
} as const;

export type PaymentFlow = (typeof PAYMENT_FLOWS)[keyof typeof PAYMENT_FLOWS];
